import React, { useState , useEffect } from "react";
import { useNavigate } from "react-router-dom";
import loader from "../../assets/Images/loader.gif";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const CustomerInfra = () => {
  const [searchServiceId, setSearchServiceId] = useState("");
  const [searchFilterData, setSearchFilterData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSearchServiceID = async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: "getInfoCustomerInfra",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        SearchValue: searchServiceId,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const result = await response.json();
      // console.log("customer infra", result);
      if (result && result.Response && result.Response.StatusCode === 200) {
        setSearchFilterData(result.Response.Data); 
        sessionStorage.setItem("canId",searchServiceId);
      } else {
        toast.warning(result.Message , {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const canId = searchParams.get("CanId");

  useEffect(() => {
    const fetchCutomerInfraDetail = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getInfoCustomerInfra",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          SearchValue: canId,
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const result = await response.json();
        // console.log(result.Response.Data);
        setSearchFilterData(result.Response.Data); 
        // setCustomerInfo(result.Response.Data[0]);
      } catch (error) {
        console.error("Error fetching ETR reasons:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCutomerInfraDetail();
  }, [canId]);

  const navigate = useNavigate();
  const redirectDashboardPage = () => {
    navigate("/dashboard");
  };

  const redirectCustomerInfra = () =>{
    navigate("/customerInfraForm");
  }

  return (
    <>
    {/* ******************header********************** */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectDashboardPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">Customer Infra Details</span>
        </div>
      </div>
    {/* *********************Header end *************************** */}
      <div
        className="container-fluid mb-1  p-2 Searchbar-bg"
        style={{ marginTop: "63px" }}
      >
        <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
          <span>
            <input
              type="text"
              className="search-box p-1 border-0"
              placeholder="Search with SERVICE ID"
              style={{ width: "250px" }}
              value={searchServiceId}
              onChange={(e) => setSearchServiceId(e.target.value)}
            />
            <i
              className="fas fa-search text-secondary"
              style={{ marginLeft: "-25px" }}
            ></i>
          </span>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button
            className="btn-sm border-0 bg-light"
            onClick={handleSearchServiceID}
          >
            Search
          </button>
        </div>
      </div>

      {/* *************cards area************************* */}
      {loading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={loader} alt="loading...."></img>
          </div>
        </div>
      ) : (
        <div className="container-fluid mt-2">
          <div className="row justify-content-center">
            {searchFilterData.map((custmerInfo, index) => (
              <div className=" col-12 col-md-6" key={index}>
                <div className="card mb-3 mt-2  mx-auto shadow">
                  <div className="p-2 m-2 srDetails-card">
                    
                      {/* <div className="card-data-row">
                        <span className="card-data-text">Service Id :</span>
                        <span className="card-data-value">
                          {custmerInfo.CANId}
                        </span>
                      </div> */}
                      <div className="row">
                          <div className="col-4 text-weight-color">Service Id</div>
                          <div className="col-1 ">:</div>
                          <div className="col-7">{custmerInfo.CANId}</div>
                      </div>
                      <div className="row">
                          <div className="col-4 text-weight-color" >Customer Name</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{custmerInfo.CustomerName}</div>
                      </div>
                      <div className="row">
                          <div className="col-4 text-weight-color">City</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{custmerInfo.City}</div>
                      </div>
                      
                      {/* <div className="card-data-row">
                        <span className="card-data-text">City :</span>
                        <span className="card-data-value">
                          {custmerInfo.City}
                        </span>
                      </div> */}
                      <div className="row">
                          <div className="col-4 text-weight-color" style={{whiteSpace:"nowrap"}}>Email Address </div>
                          <div className="col-1">:</div>
                          <div className="col-7">{custmerInfo.EmailAddress}</div>
                      </div>
                      
                      <div className="row">
                          <div className="col-4 text-weight-color">Product </div>
                          <div className="col-1">:</div>
                          <div className="col-7">{custmerInfo.Product}</div>
                      </div>

                      {/* <div className="card-data-row">
                        <span className="card-data-text">Product :</span>
                        <span className="card-data-value">
                          {custmerInfo.Product}
                        </span>
                      </div> */}
                      <div className="row">
                          <div className="col-4 text-weight-color">Segment </div>
                          <div className="col-1">:</div>
                          <div className="col-7">{custmerInfo.Segement}</div>
                      </div>
                      {/* <div className="card-data-row">
                        <span className="card-data-text">Segment :</span>
                        <span className="card-data-value">
                          {custmerInfo.Segement}
                        </span>
                      </div> */}
                    

                    <div className="text-center mt-5">
                        <button className="btn view-btn rounded-pill text-light" onClick={redirectCustomerInfra}>View</button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default CustomerInfra;
